<template>
  <div class="overlay" @click.self="handleOverlayClick">
    <div class="sales-editor">
      <h3 class="text-xl text-center mb-6">{{ title }}</h3>
      <form>
        <div class="container mx-auto">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="colA">
              <div class="input-group">
                <label for="sales_date">Sales Date</label>
                <input type="date" id="sales_date" v-model="form.sales_date" />
              </div>
              <div class="input-group">
                <label for="load_num">Load Number</label>
                <input type="text" id="load_num" v-model="form.load_num" />
              </div>
              <div class="input-group">
                <label for="type">Type</label>
                <input type="text" id="type" v-model="form.type" />
              </div>
              <div class="input-group">
                <label for="num_of_head">Number of Head</label>
                <input
                  type="text"
                  id="num_of_head"
                  v-model="form.num_of_head"
                />
              </div>
              <div class="input-group">
                <label for="customer">Customer</label>
                <input type="text" id="customer" v-model="form.customer" />
              </div>
              <div class="input-group">
                <label for="destination">Destination</label>
                <input
                  type="text"
                  id="destination"
                  class="w-full"
                  v-model="form.destination"
                />
              </div>
              <div class="input-group">
                <label for="truck_num">Truck Number</label>
                <input type="text" id="truck_num" v-model="form.truck_num" />
              </div>
            </div>
            <div class="colB">
              <div class="input-group">
                <label for="pen_num">Pen Number</label>
                <input type="text" id="pen_num" v-model="form.pen_num" />
              </div>
              <div class="input-group">
                <label for="scale_weight">Scale Weight</label>
                <input
                  type="text"
                  id="scale_weight"
                  v-model="form.scale_weight"
                />
              </div>
              <div class="input-group">
                <label for="lot_num">Lot Number</label>
                <input type="text" id="lot_num" v-model="form.lot_num" />
              </div>
              <div class="input-group">
                <label for="pasture">Pasture</label>
                <input type="text" id="pasture" v-model="form.pasture" />
              </div>
              <div class="input-group">
                <label for="time_of_delivery">Time Of Delivery</label>
                <input
                  type="text"
                  id="time_of_delivery"
                  class="w-full"
                  v-model="form.time_of_delivery"
                />
              </div>
              <div class="input-group">
                <label for="invoice">Invoice</label>
                <input type="text" id="invoice" v-model="form.invoice" />
              </div>
              <div class="input-group">
                <label for="remarks">Remarks</label>
                <input
                  type="text"
                  id="remarks"
                  class="w-full"
                  v-model="form.remarks"
                />
              </div>
            </div>
            <div class="colC">
              <div class="input-group">
                <label for="off_truck_weight">Off Truck Wt</label>
                <input
                  type="text"
                  id="off_truck_weight"
                  v-model="form.off_truck_weight"
                />
              </div>
              <div class="input-group">
                <label for="time_unloaded">Time Unloaded</label>
                <input
                  type="text"
                  id="time_unloaded"
                  v-model="form.time_unloaded"
                />
              </div>
              <div class="input-group">
                <label for="time_loaded">Time Loaded</label>
                <input
                  type="text"
                  id="time_loaded"
                  v-model="form.time_loaded"
                />
              </div>
              <div class="input-group">
                <label for="salesman">Salesman</label>
                <input type="text" id="salesman" v-model="form.salesman" />
              </div>
              <div class="input-group">
                <label for="freight">Freight</label>
                <input type="text" id="freight" v-model="form.freight" />
              </div>
              <div class="grid grid-cols-2 gap-4">
                <div class="input-group">
                  <label for="rate">Rate</label>
                  <input
                    type="text"
                    id="rate"
                    class="w-full"
                    v-model="form.rate"
                  />
                </div>
                <div class="input-group">
                  <label for="miles">Miles</label>
                  <input
                    type="text"
                    id="miles"
                    class="w-full"
                    v-model="form.miles"
                  />
                </div>
              </div>

              <div class="input-group">
                <label for="bill_of_lading">Bill of Lading</label>
                <input
                  type="text"
                  id="bill_of_lading"
                  v-model="form.bill_of_lading"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="editor-actions mt-8">
        <div class="actions-left">
          <button
            class="btn btn-red"
            @click="toggleConfirmDelete"
            v-if="editId && !showConfirmDelete"
          >
            Delete
          </button>
          <p class="mr-2" v-if="showConfirmDelete">
            Please confirm this action:
          </p>
          <button
            class="btn btn-secondary mr-2"
            @click="toggleConfirmDelete"
            v-if="editId && showConfirmDelete"
          >
            Nevermind
          </button>
          <button
            class="btn btn-red"
            @click="handleDelete"
            v-if="editId && showConfirmDelete"
          >
            Confirm Delete
          </button>
        </div>
        <div class="actions-right">
          <button class="btn btn-secondary mr-4" @click="handleOverlayClick">
            Cancel
          </button>
          <button class="btn btn-main" @click="handleCreate" v-if="!editId">
            Create
          </button>
          <button class="btn btn-main" @click="handleUpdate" v-if="editId">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../database/db.js";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
export default {
  name: "SalesEditor",
  props: ["editId", "editData"],
  data() {
    return {
      form: {
        sales_date: "",
        load_num: "",
        type: "",
        num_of_head: "",
        customer: "",
        destination: "",
        truck_num: "",
        pen_num: "",
        scale_weight: "",
        lot_num: "",
        pasture: "",
        time_of_delivery: "",
        invoice: "",
        remarks: "",
        off_truck_weight: "",
        time_unloaded: "",
        time_loaded: "",
        salesman: "",
        freight: "",
        rates: "",
        miles: "",
        bill_of_lading: "",
      },
      showConfirmDelete: false,
    };
  },
  methods: {
    handleOverlayClick() {
      this.$emit("overlayClick");
    },
    handleKeydown(e) {
      if (e.key === "Escape") this.handleOverlayClick();
    },
    toggleConfirmDelete() {
      this.showConfirmDelete = !this.showConfirmDelete;
    },
    async handleCreate() {
      const mappedForm = {
        ...this.form,
        sales_date: new Date(this.form.sales_date + "T12:00:00.000"),
        created: firebase.firestore.FieldValue.serverTimestamp(),
      };
      try {
        const newRecord = await db.collection("sales").add(mappedForm);
        this.$emit("recordCreated", newRecord.id);
        this.$toasted.show("New Record Created", {
          type: "success",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      } catch (e) {
        console.error(e);
        this.$toasted.show("Error Adding Record", {
          type: "error",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      }
    },
    async handleDelete() {
      try {
        await db.collection("sales").doc(this.editId).delete();
        this.$emit("recordDeleted");
        this.$toasted.show("Record Deleted", {
          type: "success",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      } catch (e) {
        console.error(e);
        this.$toasted.show("Error Deleting Record", {
          type: "error",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      }
    },
    async handleUpdate() {
      const mappedForm = {
        ...this.form,
        sales_date: new Date(this.form.sales_date + "T12:00:00.000"),
      };
      try {
        await db.collection("sales").doc(this.editId).set(mappedForm);
        this.$emit("recordUpdated");
        this.$toasted.show("Record Updated", {
          type: "success",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      } catch (e) {
        console.error(e);
        this.$toasted.show("Error Adding Record", {
          type: "error",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      }
    },
  },
  computed: {
    title() {
      return this.editId ? "Edit Sales Log" : "New Sales Log";
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
    if (this.editData) {
      const mappedData = {
        ...this.editData,
        sales_date: new Date(this.editData.sales_date?.seconds * 1000)
          .toISOString()
          .split("T")[0],
      };
      delete mappedData.id;
      this.form = mappedData;
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
};
</script>

<style lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  justify-content: center;
  // The overlay itself scrolls (not the inner card), so a tall form on a
  // small screen scrolls to the buttons. overscroll-behavior stops the
  // scroll from chaining to the page behind it.
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
}

.sales-editor {
  // width: 50vw;
  // margin: auto centers the card when it fits, and keeps the top reachable
  // when it's taller than the viewport (unlike align-items: center).
  margin: auto;
  height: auto;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.267);
  padding: 24px;

  label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  input {
    width: 100%;
    padding: 5px 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 8px;
    height: 2.25rem;
  }

  .editor-actions {
    display: flex;
    justify-content: space-between;

    .actions-left {
      display: flex;
      align-items: center;
    }
  }
}
</style>
